import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import MarkdownRender from '@/components/text-editors/MarkdownRender';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryDescription = ({
  description,
  compact,
}) => (
  <div className={clsx('aridhia-dictionary-description mi', compact ? 'w-100' : 'w-70')}>
    <MarkdownRender value={description} />
  </div>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset } = resolveCatalogueTemplate(datasets, templates, ownProps, { dictionaries: [] });
  const dictionary = dataset.dictionaries.find((item) => item.name === dataset.activeDictionaryName);

  return (
    {
      description: dictionary?.description,
    }
  );
};

export default connect(mapStateToProps)(DictionaryDescription);
